import { render } from "./AdminRegister.vue?vue&type=template&id=78cad2d2"
import script from "./AdminRegister.vue?vue&type=script&lang=js"
export * from "./AdminRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__